import './OverViewSpeakWithTeam.scss';

import React from 'react';
import Button from '../../../../components/pages/ui/Button/Button';

import cn from 'classnames';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function OverViewSpeakWithTeam({ fields }) {
  return (
    <div className={'container speak-with-team'}>
      <div className={'wrapper'} data-aos="fade-up">
        <div className={'inner'}>
          <div className={'image'}>
            <Image alt="img" field={fields?.image} />
          </div>
          <div className={cn('image', 'mobileImage')}>
            <Image alt="img" field={fields?.mobileImage} />
          </div>
          <div className={'content'}>
            <div>
              <h1 className={'title'}>{fields?.title?.value}</h1>
              <p className={'headtext'}>{fields?.desc?.value}</p>
            </div>
            <div className={'buttonContainer'}>
              <a href={fields?.buttonUrl.value.href}>
                <Button className={'button'} variant={'secondary'} isShowTooltip={false}>
                  {fields?.buttonText?.value}
                </Button>
              </a>
            </div>
          </div>
        </div>
        <div className={'buttonMobileContainer'}>
          <a href={fields?.buttonUrl.value.href}>
            <Button className={'buttonMobile'} variant={'secondary'} isShowTooltip={false}>
              {fields?.buttonText?.value}
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
